import "./section3.scss";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Paths } from "src/navigation";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";

export const useSection3 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isMobile, isTablet, isDesktop, isLargeDesktop } = useResponsiveBp();

  /**
   * Functions
   */
  const toInsertPage = () => {
    navigate({
      pathname: Paths.DataEntry1,
      search: `?${new URLSearchParams({
        landing: "true",
        base: "true",
      }).toString()}`,
    });
  };

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    t,
    toInsertPage,
  };
};
